import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { SuccessCircleOutline, AlertCircleOutline, CloseCircleOutline } from '@olist/design-system-icons';
import { StyledBadge } from './styles.js';

const iconVariations = {
    success: React.createElement(SuccessCircleOutline, null),
    alert: React.createElement(AlertCircleOutline, null),
    error: React.createElement(CloseCircleOutline, null),
};
const Badge = (_a) => {
    var { children, variation = 'primary', showIcon = true, icon: Icon } = _a, props = __rest(_a, ["children", "variation", "showIcon", "icon"]);
    const displayDefaultIcon = Object.keys(iconVariations).includes(variation);
    const renderIcon = showIcon && (Icon || displayDefaultIcon);
    return (React.createElement(StyledBadge, Object.assign({ variation: variation }, props),
        renderIcon
            ? (Icon && React.createElement(Icon, null)) ||
                iconVariations[variation]
            : null,
        children));
};

export { Badge as default };
